import actionTypes from '../constants/action-types';

const setCriticalError = (error) => ({
  type: actionTypes.SET_CRITICAL_ERROR,
  payload: {
    error,
  },
});

export default setCriticalError;
